import { ITeam } from "./team";

export enum CreditType {
  USE = 'use',
  TRANSFER = 'transfer',
  ADD = 'add',
}

export class CreditPayload {
  amount!: number;
  from_team_id?: number;
  to_team_id?: number;
  by_user_id!: number;
  to_assessment_id?: number;
  type?: CreditType;
}

export interface ICredit extends CreditPayload {
  id?: number
  created_at?: string
  updated_at?: string
}

export interface ICreditsAutomation {
  id?: number
  created_at?: string
  updated_at?: string
  last_run?: string
  amount: number
  team_id: number
  sender_id: number
  day_of_month: number
  active: boolean
  team?: ITeam
  sender?: ITeam
}